import { useState, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoIosArrowBack } from "react-icons/io";
import { DatePicker } from "@mui/x-date-pickers";
import "../../../App.css";
import { FormControl, Menu, MenuItem, Modal, Select, TextField,} from "@mui/material";
import { useTheme } from "../../../ThemeContext";
import { ExpandMore } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Swal from "sweetalert2";
import { RiDeleteBin5Line } from "react-icons/ri";
import { DataGrid} from "@mui/x-data-grid";
import { CiViewList } from "react-icons/ci";
import { Box, Checkbox, IconButton, Typography, Avatar } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate, useParams } from "react-router-dom";
import { deleteCommentEntities, getAllNameList, newFilterEntities, postResource } from "../../../apis/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import ReactQuill from "react-quill-new";
import { useSelector } from "react-redux";
import { useFetchIssueTimeSheetLogDetailsQuery,} from "../../../slice/logdetailSlice";
import { CommonAddLogHours } from "../../common/CommonAddLogHour";
import { openInNewTab } from "../../../utils/openInNewTab";



export const ValidDailyLog = (time) => {
  const [hours, minutes] = time.split(":");
  const formattedHours = hours.padStart(2, "0");
  const formattedMinutes = minutes.padStart(2, "0");
  if (hours <= 0 || hours > 23) {
    //console.error("Hours must be less than or equal to 23.");
    toast.error("Hours must be greter than 0 and less than  23");
    return false;
  }
  if (formattedMinutes > 59) {
    //console.error("Minutes must be less than or equal to 59.");
    toast.error("Minutes must be less than or equal to 59.");
    return false;
  }
  return `${formattedHours}:${formattedMinutes}`;
};


const FilterTaskLogHoursComponent = ({ onApply, onClear, onCancel }) => {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      owner: "",
      start_date: null,
      end_date: null,
      billingType: "",
      createdBy: "",
    },
  });

  const [filteredData, setFilteredData] = useState([]);
  const { id } = useParams();
  const [showcretaedUserName, setShowcretaedUserName] = useState([]);
  const [loading, setLoading] = useState(false);
  //console.log()("filter log hours id", id);
  const usersInProjects = useSelector((state) => state.selectOptions?.userNamesByProjects);

  const onSubmit = async (data) => {
    //console.log()(data);
    setLoading(true);
    const filterLogData = {
      owner_id: data.owner,
      added_by: data.createdBy,
      start_date: data.start_date
        ? format(new Date(data.start_date), "yyyy-MM-dd")
        : null,
      end_date: data.end_date
        ? format(new Date(data.end_date), "yyyy-MM-dd")
        : null,
      billing_type: data.billingType,
    };

    try {
      const response = await newFilterEntities( "issue/timelog/filter",id, filterLogData);
      //console.log()("Task filter log hours:", response);
      if (response.session_data) {
        //console.log()("filter entries:", response.session_data);
        const { key, value } = response.session_data;
        //console.log()({
        //   key: key,
        //   value: value,
        // });

        sessionStorage.setItem(key, JSON.stringify(value));
      }

      if (response) {
        onApply(response); // Assuming response contains the data needed for onApply
        setFilteredData(response); // Update state with filtered data
        // storeFilteredResponse(response);
        toast.success(response.message || "Filter applied successfully!");
      } 
      else {
        // Handle the case where response is falsy
        toast.error("No data received from the filter. Please try again.");
      }
    } 
    catch (error) {
      //console.error("Error fetching task time logs:", error);
      const errorMsg = error.message;
      toast.error(errorMsg || "Failed to apply filter");
    } 
    finally {
      setLoading(false);
    }
  };

  const fetchCreatedByUsers = async () => {
    try {
      await getAllNameList("userDetails");
      //console.log()("getAllUsersDetails names :", response);
    } 
    catch (err) {
      //console.error("Failed to fetch createdBy users:", err);
      toast.error("Failed to fetch createdBy users");
    }
    const response = await getAllNameList("userDetails");
    //console.log()("getAllUsersDetails names :", response);
    setShowcretaedUserName(response.data);
  };

  useEffect(() => {
    // fetchAllProjectNameList();
    fetchCreatedByUsers();
    // fetchAllActivityStatus();
  }, []);
  const handleClear = () => {
    reset(); // Reset the form to default values
  };

  return (
    <div>
      {/* Header Section */}
      <div className="d-flex align-items-center justify-content-between px-4 py-3 bg-white">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>

        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red"
          >
            Clear Filter
          </button>
        </div>
      </div>

      {/* Filter Form */}
      <div className="px-4 py-3 bg-white">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3">
              {/* Row 1 */}
              <div className="col-md-12">
                <label htmlFor="owner" className="form-label">
                  Owner
                </label>
                <Controller
                  control={control}
                  name="owner"
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <Select
                        {...field}
                        labelId="owner-label"
                        id="owner"
                        {...control.register("owner")}
                        IconComponent={ExpandMore} // Add the custom icon here
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            usersInProjects.find(
                              (user) => user.user_id === selected
                            )?.name
                          ) : (
                            <span className=" lightText">Owner</span>
                          )
                        }
                      >
                        {usersInProjects.map((user, index) => (
                          <MenuItem key={index} value={user.user_id}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Start Date</label>
                <Controller
                  name="start_date"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      onChange={(date) => field.onChange(date)}
                      renderInput={(params) => (
                        <TextField {...params} className="form-control" />
                      )}
                    />
                  )}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">End Date</label>
                <Controller
                  name="end_date"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      onChange={(date) => field.onChange(date)}
                      renderInput={(params) => (
                        <TextField {...params} className="form-control" />
                      )}
                    />
                  )}
                />
              </div>

              {/* Row 2 */}
              <div className="col-md-6">
                <label className="form-label">Billing Type</label>
                <Controller
                  name="billingType"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <Select
                        {...field}
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            selected
                          ) : (
                            <span className=" lightText">Select type</span>
                          )
                        }
                      >
                        <MenuItem value="BILLABLE">BILLABLE</MenuItem>
                        <MenuItem value="NON-BILLABLE">NON-BILLABLE</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </div>

              {/* Row 3 */}
              <div className="col-md-6   paddingBtn">
                <label className="form-label">Created By</label>
                <Controller
                  name="createdBy"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <Select
                        {...field}
                        labelId="createdBy-label"
                        id="createdBy"
                        {...control.register("createdBy")}
                        IconComponent={ExpandMore} // Add the custom icon here
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            usersInProjects.find(
                              (user) => user.user_id === selected
                            )?.name
                          ) : (
                            <span className=" lightText">Owner</span>
                          )
                        }
                      >
                        {usersInProjects.map((user, index) => (
                          <MenuItem key={index} value={user.user_id}>
                            {user.name}
                          </MenuItem>
                        ))}

                        {/* Add other options as needed */}
                      </Select>
                    </FormControl>
                  )}
                />
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="bg-white position-absolute bottom-0 py-3 w-100">
              <div className="d-flex justify-content-left mt-3">
                <button type="submit" className="me-3 add_btn">
                  {loading ? "Applying..." : "Apply"}
                </button>

                <button type="button" className="cancel_btn" onClick={onCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const TaskLogHours = () => {
  const { isDarkMode } = useTheme();
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [projects, setProjects] = useState([]);
  const handleShowFilter = () => setShowFilter(true);
  const [showFilter, setShowFilter] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [showQuillPopup, setShowQuillPopup] = useState(false);
  const [quillContent, setQuillContent] = useState("");
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [showExportPage, setShowExportPage] = useState(false);
  // const [showExportPage, setShowExportPage] = useState(false);
  const [checkedRows, setCheckedRows] = useState({});
  const { id } = useParams();
  const project_id = localStorage.getItem("project_id");

  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log()("login_user in task:", login_user);
  const { role: login_user_role } = login_user;
  //console.log()("login_user role in task:", login_user_role);
  //console.log()("show log hours id", id);
  const [updatedSubtask, setUpdatedSubtask] = useState({
    // Set initial state values if required
    start_time: "",
    end_time: "",
    Date: null, // or other fields as needed
    logHourse: 0,
    dashBoard: "",
    // Add other fields if necessary
  });

  const handleDashboardSave = async () => {
    // Update the row data
    const updatedSubtask = data
      .find((project) =>
        project.subtasks.some((subtask) => subtask.id === selectedRowId)
      )
      .subtasks.find((subtask) => subtask.id === selectedRowId);

    const updatedRow = { ...updatedSubtask, dashBoard: quillContent };
    // Save to the database
    await handleSubtaskUpdate(updatedRow);

    // Update the local state
    const updatedProjects = data.map((project) => {
      // Create a deep copy of each project
      return {
        ...project,
        subtasks: project.subtasks.map((subtask) => {
          if (subtask.id === selectedRowId) {
            return { ...subtask, dashBoard: quillContent }; // Create a new subtask object
          }
          return subtask; // Return the original subtask
        }),
      };
    });

    setProjects(updatedProjects); // Update state with the new array

    // Close the popup
    setShowQuillPopup(false);
  };

  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const convertedHours = hours % 12 || 12; // Convert 0 or 12 to 12 for AM/PM format
    return `${convertedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  const { data, refetch } = useFetchIssueTimeSheetLogDetailsQuery(id);

  //console.log()("get flated show  data :", data);

  const [showProject, setShowProject] = useState(false);
  const { reset } = useForm();
  const handleShowProject = () => setShowProject(true);
  const navigate = useNavigate();
  const toggleExpandRow = (rowId) => {
    setExpandedRows((prevExpandedRows) => {
      // If the clicked row is already expanded, collapse it
      if (prevExpandedRows[rowId]) {
        return { ...prevExpandedRows, [rowId]: false };
      }
      // Otherwise, close all other rows and expand the clicked one
      return { [rowId]: true };
    });
  };

  // const handleMenuOpen = (event, taskId) => {
  //   setMenuAnchorEl(event.currentTarget);
  //   setSelectedTask(taskId);
  // };

  const handleMenuOpen = (event, rowId) => {
    if (checkedRows[rowId]) {
      // Open menu only if checkbox is checked
      setMenuAnchorEl(event.currentTarget);
      setSelectedRowId(rowId);
      setSelectedTask(rowId);
    }
  };
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  const handleViewDetails = (action) => {
    //console.log()(`${action} task: ${selectedTask}`);
    navigate(`/projects/projectDetail/${project_id}/timesheet/TimeSheetDetail/${selectedTask}`);
    handleMenuClose();
  };
  
  const handleViewDetailsInNewTab = (action) => {
    const path = `/projects/projectDetail/${project_id}/timesheet/TimeSheetDetail/${selectedTask}`;
    openInNewTab(path);
    //console.log()(`${action} task: ${selectedTask}`);
    handleMenuClose();
  };

  const handleDelete = async (action) => {
    const taskIdToDelete = selectedTask;
    handleMenuClose();
    Swal.fire({
      title: "Confirm Deletion",
      text: "Are you sure you want to delete this log hour entry?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "Cancel",
      showCloseButton: true,
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteCommentEntities(
            "timesheet/delete",
            taskIdToDelete
          );
          refetch();
          toast.success(response.message || "Log hour entry deleted successfully!");
        } 
        catch (err) {
          toast.error(err.message || "Failed to delete log hour entry");
        }
      }
    });
  };

  const getFlattenedRows = () => {
    const flattenedRows = [];

    if (filteredRows.length > 0) {
      filteredRows &&
        filteredRows.forEach((row) => {
          flattenedRows.push(row);
          if (expandedRows[row.id] && Array.isArray(row.subtasks)) {
            row.subtasks.forEach((subtask) => {
              flattenedRows.push({ ...subtask });
            });
          }
        });
    } 
    else {
      data &&
        data.forEach((row) => {
          flattenedRows.push(row);
          if (expandedRows[row.id] && Array.isArray(row.subtasks)) {
            row.subtasks.forEach((subtask) => {
              flattenedRows.push({ ...subtask });
            });
          }
        });
    }
    // filteredRows.length > 0
    // ? //console.log()("get flated rows filter here :", filteredRows)
    // : //console.log()("get flated rows filter not  :", flattenedRows);

    return flattenedRows;
  };

  const handleRowEdit = (newRow) => {
    if (!newRow.isSubtask) {
      toast.error("Only subtasks can be edited.");
      return;
    }

    //console.log()("Edited Subtask:", newRow);

    // Trigger API update
    handleSubtaskUpdate(newRow);

    // Update the state with the new data
    const updatedProjects = [...projects];
    const parentIndex = updatedProjects.findIndex(
      (project) => project.id === newRow.parentId
    );

    if (parentIndex !== -1) {
      const subtaskIndex = updatedProjects[parentIndex].subtasks.findIndex(
        (subtask) => subtask.id === newRow.id
      );

      if (subtaskIndex !== -1) {
        const updatedSubtask = {
          ...updatedProjects[parentIndex].subtasks[subtaskIndex],
          ...newRow,
          timePeriod:
            newRow.start_time && newRow.end_time
              ? `${convertTo12HourFormat(
                  newRow.start_time
                )} - ${convertTo12HourFormat(newRow.end_time)}`
              : "",
        };
        //console.log()("updatedSubtask value  :", updatedSubtask);
        //console.log()(
        //   "updatedSubtask value  time period1:",
        //   updatedSubtask.timePeriod
        // );

        updatedProjects[parentIndex].subtasks[subtaskIndex] = updatedSubtask;
        setProjects(updatedProjects); // Update the local state
      }
    }
  };

  const handleClearFilter = () => {
    // Reset projects state to original (unfiltered) data
    // setProjects(originalProjects); // Assuming `originalProjects` stores the unfiltered data
    reset(); // Reset the filter form fields
  };

  // const handleApplyFilter = (filteredData) => {
  //   setFilteredRows(filteredData.time_logs);
  //   //console.log()("get flated rows filter apply filter :", filteredRows);
  //   //console.log()("get flated rows filter data :", filteredData.time_logs);
  // };

  const handleApplyFilter = (filteredData) => {
    // Transform the response data to match the required format
    const transformedRows = filteredData.time_logs.map((log, index) => ({
      id: index,
      Date: log.log_date,
      logHourse: [
        `${log.total_hours}:00`,
        `${log.billable_hours}:00`,
        `${log.non_billable_hours}:00`,
      ],
      timePeriod: "",
      dashBoard: "",
      isTask: true,
      subtasks: Array.isArray(log.time_logs)
        ? log.time_logs.map((timeLog, subIndex) => {
            const text = timeLog.notes;
            const clearNotes = document.createElement("div");
            clearNotes.innerHTML = text;
            const textNotes = clearNotes.innerText.trim();
            const timePeriod =
              timeLog.start_time == null || timeLog.end_time == null
                ? ""
                : `${convertTo12HourFormat(
                    timeLog.start_time
                  )} - ${convertTo12HourFormat(timeLog.end_time)}`;

            return {
              id: timeLog.time_logs_id, // Include unique id
              timeLogId: timeLog.time_logs_id, // Include time_logs_id
              user: timeLog.added_name,
              logHourse: timeLog.hours_in_text,
              Date: log.log_date,
              timePeriod: timePeriod,
              dashBoard: textNotes,
              start_time: timeLog.start_time, // Add start_time
              end_time: timeLog.end_time, // Add end_time
              billingType: timeLog.billing_type,
              added_name: timeLog.added_name,
              isSubtask: true,
              parentId: index, // This will reference the parent task index
            };
          })
        : [],
    }));

    // Set the transformed rows to the state
    setFilteredRows(transformedRows);
    setShowFilter(false);
    //console.log()(" get flated Original Filtered Data:", filteredData.time_logs);
    //console.log()(" get flated Original Filtered rows response :", filteredRows);
    //console.log()(" get flated Transformed Filtered Rows:", transformedRows);
  };

  // useEffect(() => {
  //   //console.log()("hadleapply filter :", filteredRows);
  //   handleApplyFilter();
  // }, [filteredRows]);
  useEffect(() => {
    //console.log()("get flated in state:", filteredRows); // Log whenever state updates
  }, [filteredRows]);
  // Function to format time to HH:mm (hours and minutes only)
  const formatTimeToHM = (time) => {
    if (!time) return "00:00"; // Default if no time is provided
    const [hours, minutes] = time.split(":").map(Number);
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`; // Format to HH:mm
  };

  const handleTimeChange = (field, value) => {
    setUpdatedSubtask({
      ...updatedSubtask,
      [field]: value,
    });
  };
  const formatTimeTo24Hour = (time) => {
    const isPM = time.toUpperCase().includes("PM");
    const isAM = time.toUpperCase().includes("AM");

    const [hours, minutes] = time
      .replace(/AM|PM/i, "") // Remove AM/PM
      .trim()
      .split(":")
      .map(Number);

    if (isNaN(hours) || isNaN(minutes)) {
      throw new Error(`Invalid time value: ${time}`);
    }

    let formattedHours = hours;
    if (isPM && hours !== 12) {
      formattedHours += 12; // Convert PM to 24-hour format
    } 
    else if (isAM && hours === 12) {
      formattedHours = 0; // Convert 12 AM to 0 (midnight)
    }

    return `${formattedHours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  // const handleSubtaskUpdate = async (updatedSubtask) => {
  //   //console.log()("Updated Subtask before API call:", updatedSubtask);

  //   let startTime = null;
  //   let endTime = null;

  //   // Extract startTime and endTime from timePeriod if available
  //   if (updatedSubtask.timePeriod) {
  //     const [startTimeRaw, endTimeRaw] = updatedSubtask.timePeriod
  //       .split("-")
  //       .map((time) => time.trim());

  //     try {
  //       startTime = startTimeRaw ? formatTimeTo24Hour(startTimeRaw) : null;
  //       endTime = endTimeRaw ? formatTimeTo24Hour(endTimeRaw) : null;

  //       //console.log()("Formatted startTime:", startTime);
  //       //console.log()("Formatted endTime:", endTime);

  //       if (startTime === endTime) {
  //         toast.error("Start time and end time cannot be the same.");
  //         return;
  //       }
  //     } catch (err) {
  //       //console.error("Error formatting time:", err.message);
  //       toast.error("Invalid time format in timePeriod.");
  //       return; // Stop execution if time formatting fails
  //     }
  //   }

  //   // Construct postData dynamically based on available fields
  //   const postData = {
  //     log_date: updatedSubtask.Date,
  //     // billing_type: "Billable",
  //     notes: updatedSubtask.dashBoard || "",
  //   };
  //   if (!startTime || !endTime) {
  //     postData.hours_in_text = updatedSubtask.logHourse;
  //   }

  //   // Include start_time and end_time only if they are valid
  //   if (startTime && endTime) {
  //     postData.start_time = startTime;
  //     postData.end_time = endTime;
  //   }

  //   //console.log()("Post data before API call:", postData);

  //   try {
  //     const response = await postResource(
  //       "task/timelog",
  //       "update",
  //       updatedSubtask.timeLogId,
  //       postData
  //     );

  //     //console.log()("Subtask Update API Response:", response);
  //     toast.success(response.message || "Subtask updated successfully.");
  //     refetch();
  //   } catch (err) {
  //     //console.error("Error in handleSubtaskUpdate:", err.message);
  //     toast.error(err.message || "Error updating subtask.");
  //   }
  // };

  const handleSubtaskUpdate = async (updatedSubtask) => {
    //console.log()("Updated Subtask before API call:", updatedSubtask);

    let startTime = null;
    let endTime = null;

    // Validate hours_in_text format (HH:mm)
    const isValidTimeFormat = (time) =>
      /^([01]\d|2[0-3]):([0-5]\d)$/.test(time);

    // Validate date format (YYYY-MM-DD)
    const isValidDateFormat = (date) => /^\d{4}-\d{2}-\d{2}$/.test(date);

    if (
      updatedSubtask.logHourse &&
      !isValidTimeFormat(updatedSubtask.logHourse)
    ) {
      toast.error("Invalid time format. Use HH:mm (e.g., 08:59).");
      return;
    }

    if (updatedSubtask.Date && !isValidDateFormat(updatedSubtask.Date)) {
      toast.error("Invalid date format. Use YYYY-MM-DD.");
      return;
    }

    // Extract startTime and endTime from timePeriod if available
    if (updatedSubtask.timePeriod) {
      const [startTimeRaw, endTimeRaw] = updatedSubtask.timePeriod
        .split("-")
        .map((time) => time.trim());

      try {
        startTime = startTimeRaw ? formatTimeTo24Hour(startTimeRaw) : null;
        endTime = endTimeRaw ? formatTimeTo24Hour(endTimeRaw) : null;

        //console.log()("Formatted startTime:", startTime);
        //console.log()("Formatted endTime:", endTime);

        if (startTime === endTime) {
          toast.error("Start time and end time cannot be the same.");
          return;
        }
      } catch (err) {
        //console.error("Error formatting time:", err.message);
        toast.error("Invalid time format in timePeriod.");
        return; // Stop execution if time formatting fails
      }
    }

    // Construct postData dynamically based on available fields
    const postData = {
      log_date: updatedSubtask.Date,
      notes: updatedSubtask.dashBoard || "",
    };

    // Check if hours_in_text is being updated
    if (
      updatedSubtask.logHourse !== undefined &&
      updatedSubtask.logHourse !== null
    ) {
      postData.hours_in_text = updatedSubtask.logHourse;
    } else if (startTime && endTime) {
      // Only set start_time and end_time if hours_in_text is not updated
      postData.start_time = startTime;
      postData.end_time = endTime;
    }

    //console.log()("Post data before API call:", postData);

    try {
      const response = await postResource( "task/timelog", "update", updatedSubtask.timeLogId, postData);
      //console.log()("Subtask Update API Response:", response);
      toast.success(response.message || "Subtask updated successfully.");
      refetch();
    } 
    catch (err) {
      //console.error(
      //   "Error in handleSubtaskUpdate:",
      //   err.response?.data?.message
      // );
      toast.error(err.errors || err.response?.data?.errors);
    }
  };
  const handleDashboardClick = (row) => {
    setSelectedRowId(row.id);
    setQuillContent(row.dashBoard || ""); // Load existing notes or empty
    setShowQuillPopup(true);
  };

  useEffect(() => {
    // showAllTimeLogEntities();
  }, []);

  const handleExportPage = () => {
    setShowExportPage(true);
  };

  const hadleExport = (exportData) => {
    setShowExportPage(false);
  };

  const handleCheckboxChange = (rowId) => {
    setCheckedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId], // Toggle checkbox state
    }));
  };

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          {params.row.isTask && (
            <IconButton onClick={() => toggleExpandRow(params.row.id)}>
              {expandedRows[params.row.id] ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </IconButton>
          )}
          {params.row.isSubtask && (
            <Checkbox
              checked={!!checkedRows[params.row.id]} // Ensure boolean value
              onChange={() => handleCheckboxChange(params.row.id)}
            />
          )}
          <IconButton
            onClick={(event) => handleMenuOpen(event, params.row.id)}
            disabled={!checkedRows[params.row.id]} // Disable if checkbox is unchecked
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
      ),
    },
    {
      field: "user",
      headerName: "Task",
      width: 240,
      editable: false, // The main task row doesn't need to be editable
      renderCell: (params) => {
        if (params.row.isTask) {
          // Display log_date for task rows
          return (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: "bold" }}>
                {login_user_role != "EMPLOYEE"
                  ? params.row.userName
                  : params.row.Date}
              </span>
            </Box>
          );
        } else if (params.row.isSubtask) {
          // Display the username for subtasks
          // if (!params.value) return "—"; // Default fallback for undefined usernames
          const initials = params.value
            .split(" ")
            .map((word) => word[0])
            .slice(0, 2)
            .join("")
            .toUpperCase(); // Extract initials from name
          return (
            <Box display="flex" alignItems="center" gap={1}>
              <Avatar
                sx={{
                  bgcolor: "#1976d2",
                  width: 24,
                  height: 24,
                  fontSize: "0.75rem",
                }}
              >
                {initials}
              </Avatar>
              <span>{params.value}</span>
            </Box>
          );
        }
        // Default fallback
      },
    },
    {
      field: "logHourse",
      headerName: "Daily Log Hours",
      width: 200,
      editable: login_user_role === "CLIENT" ? false : true,
      align: "start",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              <span>{params.value}</span>
            </Box>
          );
        }
        const logHours = Array.isArray(params.value)
          ? params.value
          : [params.value];
        const getColor = (index) => {
          if (params.row.isSubtask) return "black";
          return index === 0 ? "#00BF00" : index === 1 ? "#34C1FD" : "#FF955A";
        };
        return (
          <Box sx={{ display: "flex", gap: "8px" }}>
            {logHours.map((hour, index) => (
              <Box
                key={index}
                sx={{ color: getColor(index), fontWeight: "bold" }}
              >
                {hour}
              </Box>
            ))}
          </Box>
        );
      },
    },
    {
      field: "Date",
      headerName: "Date",
      width: 150,
      editable: login_user_role === "CLIENT" ? false : true,
      align: "left",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              {/* edit data */}
              {/* <CustomCalendar /> */}
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },
    {
      field: "timePeriod",
      headerName: "Time Period",
      width: 180,
      align: "left",
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              {/* edit data */}
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },

    {
      field: "dashBoard",
      headerName: "Notes",
      width: 150,
      align: "left",
      // editable: (params) => params.row.isSubtask,
      editable: login_user_role === "CLIENT" ? false : true,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <div
              // className=" d-flex align-items-center justify-content-center w-100 h-100 "
              onClick={() => handleDashboardClick(params.row)} // Entire cell clickable
            >
              {params.value || "Edit Notes"}
            </div>
          );
        }
        return null; // Return null for non-subtasks
      },
    },
    {
      field: "billingType",
      headerName: "Status",
      align: "left",
      width: 200,
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box mt={2}>
              {/* edit data */}
              <Typography
                sx={{
                  color: params.value === "BILLABLE" ? "#34C1FD" : "#FF955A",
                }}
              >
                {params.value}
              </Typography>
            </Box>
          );
        }
        return null; // Return null for non-subtasks
      },
    },
    {
      field: "timesheet_type",
      headerName: "Type",
      width: 100,
      editable: false,
      // renderCell: (params) => {
    },
    {
      field: "added_name",
      headerName: "Added By",
      width: 200,
      editable: false,
      // renderCell: (params) => {
    },
    {
      field: "reported_manager_name",
      headerName: "Report To",
      width: 200,
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          const value = params.value;
          if (!value || value.toLowerCase?.() === "none") {
            return "------------";
          }
          return value;
        }
        return null;
      },
    },
    {
      field: "approval_status",
      headerName: "OT Status ",
      width: 200,
      editable: false,
    },
  ];
  const handleCloseProject = () => {
    setShowProject(false);
  };
  return (
    <>
      <Offcanvas show={showProject} placement="end" style={{ width: "50%" }}>
        <Offcanvas.Body className="p-0">
          {/* <AddSubTaskLogHoursComponent
            onApply={(filters) => setShowProject(false)}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
          /> */}
          <CommonAddLogHours
            onApply={handleCloseProject}
            onClear={() => reset()}
            onCancel={handleCloseProject}
            // span={"today"}
            // fromDate={fromDate}
            // toDate={toDate}
            refetchList={refetch}
            isModule={false}
            isDetail={true}
            TaskOrIssueId={id}
            isTaskOrIssue="issue"
          />
        </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <FilterTaskLogHoursComponent
            onApply={handleApplyFilter}
            onClear={handleClearFilter}
            onCancel={() => setShowFilter(false)}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <div style={{ padding: "16px", backgroundColor: isDarkMode ? "transparent" : undefined }} className={isDarkMode ? "" : "bg-white"}>
        <Box style={{ width: "100%", backgroundColor: "transparent" }}>
          <Box
            className="d-flex justify-content-end align-items-center gap-2"
            sx={{
              border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
              borderRadius: "6px",
              padding: "12px 16px",
              marginBottom: "12px",
              backgroundColor: isDarkMode ? "transparent" : "#fff",
              marginTop: "-5px",
            }}
          >
              {login_user_role !== "CLIENT" && (
                <button className="add_btn" onClick={handleShowProject}>
                  Add Log Hours
                </button>
              )}
          </Box>

          <DataGrid
            rows={getFlattenedRows()}
            columns={columns}
            getRowId={(row) => row.id}
            hideFooter
            disableSelectionOnClick
            autoHeight
            // processRowUpdate={(newRow) => {
            //   //console.log()("newRowwwwwwwww:", newRow);

            //   handleRowEdit(newRow); // Update only subtasks
            //   return newRow; // Required for DataGrid to finalize the row update
            // }}
            processRowUpdate={(updatedRow, originalRow) => {
              if (!originalRow.isSubtask) {
                console.warn("Row_editing_blocked.");
                toast.error("Only subtasks can be edited.");
                return originalRow; // Prevent update
              }
              handleRowEdit(updatedRow);
              return updatedRow;
            }}
          />
          <Modal open={showQuillPopup} onClose={() => setShowQuillPopup(false)}>
            <Box
              className="bg-white"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 600,
                maxWidth: 500,
                height: 300,
                // bgcolor: "background.paper",
                boxShadow: 10,
                p: 2,
              }}
            >
              <ReactQuill
                theme="snow"
                value={quillContent}
                onChange={(content) => setQuillContent(content)} // Update state
                style={{ height: "150px", marginBottom: "20px" }}
              />
              <Box
                display="flex"
                marginTop={10}
                justifyContent="flex-end"
                gap={2}
              >
                <button
                  className="cancel_btn"
                  onClick={() => setShowQuillPopup(false)}
                >
                  Cancel
                </button>
                <button className="add_btn" onClick={handleDashboardSave}>
                  Save
                </button>
              </Box>
            </Box>
          </Modal>

          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleViewDetails("View")}>
              <CiViewList className="me-2" color="blue" />
              View Details
            </MenuItem>
            <MenuItem
              onClick={() => handleViewDetailsInNewTab("View in New Tab")}
            >
              <CiViewList className="me-2" color="blue" />
              View Details in New Tab
            </MenuItem>
            <MenuItem onClick={() => handleDelete("Delete")}>
              <RiDeleteBin5Line className="me-2 text-danger" size={17} />
              Delete
            </MenuItem>
            {/* <MenuItem onClick={() => handleMenuAction("Clone")}>Clone</MenuItem> */}
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default TaskLogHours;
